import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "corner.inside.arc.16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fillRule: "evenodd", fill: "currentColor" },
        React.createElement("path", { d: "M8.75 2.75H14V14H2.75V8.75a6 6 0 006-6z", fillOpacity: 0.15 }),
        React.createElement("path", { d: "M14 2v1.5H9.457l-.021.185a6.754 6.754 0 01-5.751 5.75l-.185.022V14H2V8h.75a5.25 5.25 0 005.246-5.034L8 2.75V2h6z", fillRule: "nonzero" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
